module.exports = __webpack_public_path__ + "static/media/SPECIAL_DIET.4f181e54.svg";